"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var createFeature_1 = require("../createFeature");
exports.setHiddenAction = (_a = createFeature_1.createInputFeature('hidden'), _a.actionCreator), exports.hiddenSelector = _a.selectorCreator, exports.HiddenFeature = _a.featureReducer;
//# sourceMappingURL=hidden.js.map